import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { AuditLogComponent } from './audit-log.component';
import { AuditLogGridComponent } from './audit-log-grid/audit-log-grid.component';
import { AuditLogFilterComponent } from './audit-log-filter/audit-log-filter.component';
import { GridsterModule } from 'angular-gridster2';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { WidgetsModule } from '../../widgets/widgets.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AuditTrailUsernameComponent } from './audit-trail/audit-trail-username/audit-trail-username.component';
import { AuditGuard } from './audit.guard';
import { LoginUsageReportComponent } from './usage-report/usage-report.component';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
    imports: [
        AgGridModule,
        // angular
        CommonModule,
        // 3rd party
        GridsterModule,
        // kendo
        TooltipModule,
        DropDownsModule,
        // project
        WidgetsModule
    ],
    providers: [
        AuditGuard
    ],
    declarations: [
        AuditTrailComponent,
        AuditLogComponent,
        AuditLogGridComponent,
        AuditLogFilterComponent,
        AuditTrailUsernameComponent,
        LoginUsageReportComponent
    ],
    exports: [
        AuditTrailComponent,
        LoginUsageReportComponent
    ]
})
export class AuditLogModule { }
